import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from './App';
import Header from './components/Header';
import './styles/global.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { AccountProvider } from './context/AccountContext';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AccountProvider>
        <Header />
        <App />
        <Analytics />
        <SpeedInsights />
      </AccountProvider>
    </BrowserRouter>
  </React.StrictMode>
);